module.exports = __webpack_public_path__ + "static/media/Logo-sample-4.45194347.png";